import { render, staticRenderFns } from "./IconPayBonus.vue?vue&type=template&id=bfcb67e0&"
import script from "./IconPayBonus.vue?vue&type=script&lang=js&"
export * from "./IconPayBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports